import React from 'react'
import { useFormState } from 'react-final-form'
import { Prompt } from 'react-router'

interface FormPromptProps {
  condition?: boolean
}

export function FormPrompt(props: FormPromptProps) {
  const { condition } = props
  const { pristine, submitSucceeded, dirtySinceLastSubmit } = useFormState({
    subscription: {
      pristine: true,
      submitSucceeded: true,
      dirtySinceLastSubmit: true,
    },
  })

  return <Prompt when={(!pristine && (!submitSucceeded || dirtySinceLastSubmit)) || condition} message='' />
}

FormPrompt.defaultProps = {
  condition: false,
} as FormPromptProps
